export default __webpack_public_path__ + "static/media/HSC_Full_hero_video.c6a7bce3.mp4";